module.exports = __webpack_public_path__ + "static/media/radio-lared.54068019.png";